<template>
  <div class="main-container">
    <div class="Authcontainer hidden-sm-and-down">
      <div class="formbox" ref="formbox">
        <h3>授权查询</h3>
        <div class="jumbotron_title" ref="jumbotron_title">
          <el-input
            v-model.trim="wechat"
            class="wechat"
            @keydown.enter.native="onSubmit()"
            placeholder="输入授权直营零售商微信或企业全称"></el-input>
          <button class="button btn" @click="onSubmit">
            查询
          </button>
          <div>
              <p class="nrts" v-if="tps">请输入授权直营零售商微信号或企业全称</p>
              <p class="nrts" v-if="hidden">对不起，您所查询的号码或企业名称（<b style="color:red;">{{ text }}</b>）不完整或未经耒阳市刘燕酿制生物科技有限公司通过审核授权，请谨慎咨询与购买，凡未经我司审核颁发代理授权者，我司不承担任何法律责任。</p>
              <img style="width: 100%;padding-top:5%" v-if="imgs" :src="imagesurl+this.imgUrl" alt="">
            </div>
              <p class="Pcursor" @click="centerDialogVisible = true">
              * 已遵守中华人民共和国电子商务法声明书
            </p>
            <p style="text-align: center;font-size:18px;margin-top: 3%;font-weight: 600;"><a href="#" style="color:red" @click="presaleVisible = true">*售前阅读</a></p>
        </div>
      </div>
    </div>
  
  <!-- 手机端显示 -->
  <div class="hidden-md-and-up mobAuthcontainer">
        <div class="formbox">
        <div class="jumbotron_title">
          <h3>授权查询</h3>
          <el-input
            v-model.trim="wechat"
            class="wechat"
            placeholder="输入授权直营零售商微信或企业全称"></el-input>
          <button class="button btn" @click="onSubmit">
            查询
          </button>
          <div>
              <p class="nrts" v-if="tps">请输入授权直营零售商微信号或企业全称</p>
              <p class="nrts" v-if="hidden">对不起，您所查询的号码或企业名称（<b style="color:red;">{{ text }}</b>）不完整或未经耒阳市刘燕酿制生物科技有限公司通过审核授权，请谨慎咨询与购买，凡未经我司审核颁发代理授权者，我司不承担任何法律责任。</p>
              <img style="width: 100%;border:1px solid #00383F;margin-top:0.6rem" v-if="imgs" :src="imagesurl+this.imgUrl" alt="">
            </div>
              <p class="Pcursor" @click="centerDialogVisible = true">
              * 已遵守中华人民共和国电子商务法声明书
            </p>
             <a href="#" style="color:red" @click="presaleVisible = true">*售前阅读</a>
        </div>
      </div>
  </div>

        <el-dialog
            title="中华人民共和国电子商务法"
            :visible.sync="centerDialogVisible"
             width="7rem"
            center>
            <div class="way">
              <p>中华人民共和国电子商务法，是政府调整、企业和个人以数据电文为交易手段，通过信息网络所产生的，因交易形式所引起的各种商事交易关系，以及与这种商事交易关系密切相关的社会关系、政府管理关系的法律规范的总称。</p>
              <p>2013年12月7号，中国全国人大常委会正式启动了《中华人民共和国电子商务法》的立法进程。</p>
              <p>2018年8月31日，十三届全国人大常委会第五次会议表决通过《电子商务法》，自2019年1月1日起施行。</p>
              <p id="name"><span>中文名：中华人民共和国电子商务法</span><span>外文名：Electronic commerce law</span></p>
              <h3>立法背景</h3>
              <p>电子商务是指通过电子行为进行的商事活动。这种观点以1996年《联合国电子商务示范法》为代表。广义的电子商务是指通过电子行为进行民商事活动。商事活动的范围被民商事活动所覆盖。依通说，商事活动是以盈利为目的、具有营业性的民事行为，而民商事行为的外延显然大于商事行为，它不仅包括商事行为，也包括非商事主体之间的民事活动。事实也是如此，电子商务中的“商务”并非名副其实，他不仅包括“商事行为”，也包括非商事行为，例如自然人之间的电子商务。</p>
              <h3>法律定义</h3>
              <p>电子商务法是指调整平等主体之间通过电子行为设立、变更和消灭财产关系和人身关系的法律规范的总称；是政府调整、企业和个人以数据电文为交易手段，通过信息网络所产生的，因交易形式所引起的各种商事交易关系，以及与这种商事交易关系密切相关的社会关系、政府管理关系的法律规范的总称。</p>
              <h3>发展状况</h3>
              <h4>立法背景</h4>
              <p>
                2012年，中国电子商务交易额达7.85万亿元，同比增长30.8%；网络零售额超过1.3万亿元，占社会消费品零售总额的6.3%；电子商务服务企业直接从业人员超过200万人，间接带动就业人数超过1500万人。根据有关部门和专家分析预测，到“十二五”末，中国网民总数将达7亿人，电子商务交易额、网络零售交易额将分别增长至18万亿和3万亿元以上，中国将成为全球规模最大的电子商务市场，电子商务产业将成为最具发展潜力、最有国际竞争力的产业。与电子商务迅猛发展的实践相比，中国至今尚未对电子商务进行专门立法，实践中规范、指导电子商务发展主要依靠部门规章。电子商务现有法律法规亟待梳理、补充、修改和完善。促进电子商务持续健康发展迫切需要加强立法。</p>
              <p>国务院办公厅出台了关于加快电子商务发展的若干意见。国家发改委、国务院信息办发布了电子商务发展“十一五”规划。工信部发布了电子商务“十二五”发展规划。商务部先后发布了关于网上交易的指导意见、关于“十二五”电子商务发展指导意见等。国家工商总局发布了《网络商品交易及有关服务行为管理暂行办法》。</p>
              <h4>立法进程</h4>
              <p>2000年12月，中国全国人大常委会审议通过了《关于维护互联网安全的决定》；2004年8月通过了《电子签名法》；2012年12月份，通过了《关于加强网络信息保护的决定》。</p>
              <p>2013年12月7号，全国人大常委会在人民大会堂上召开了《电子商务法》第一次起草组的会议，正式启动了《电子商务法》的立法进程。12月27日，全国人大财经委在人民大会堂召开电子商务法起草组成立暨第一次全体会议，正式启动电子商务法立法工作。根据十二届全国人大常委会立法规划，电子商务法被列入第二类立法项目，即需要抓紧工作，条件成熟时提请常委会审议的法律草案。</p>
              <p>2014年11月24日，中国全国人大常委会将于召开电子商务法起草组第二次全体会议，将就电子商务重大问题和立法大纲进行研讨。起草组已经明确提出，《电子商务法》要以促进发展、规范秩序、维护权益为立法的指导思想。</p>
              <p>2015年1月至2016年6月，开展并完成电子商务法草案起草。</p>
              <p>2016年3月10日，全国人大财政经济委员会副主任委员乌日图透露，电子商务立法已列入十二届全国人大常委会五年立法规划，目前法律草案稿已经形成，将尽早提请审议。</p>
              <p>2016年12月19日，十二届全国人大常委会第二十五次会议上，全国人大财政经济委员会提请审议电子商务法草案。</p>
              <p>2016年12月27日至2017年1月26日，电子商务法在中国人大网向全国公开电子商务立法征求意见。</p>
              <p>2018年6月19日，电子商务法草案三审稿提请十三届全国人大常委会第三次会议审议。</p>
              <p>2018年8月27日至8月31日举行的第十三届全 国人大常委会第五次会议正在对电子商务法草案进行四审。</p>
              <p>
                2018年8月31日，全国人大常委会表决通过电子商务法，其中明确规定：对关系消费者生命健康的商品或者服务，电商平台经营者对平台内经营者的资质资格未尽到审核义务，或者对消费者未尽到安全保障义务，造成消费者损害的，依法承担相应的责任。电商平台经营者对平台内经营者侵害消费者合法权益行为未采取必要措施，或者对平台内经营者未尽到资质资格审核义务，或者对消费者未尽到安全保障义务的，由市场监督管理部门责令限期改正，可以处五万元以上五十万元以下的罚款；情节严重的，责令停业整顿，并处五十万元以上二百万元以下的罚款。</p>
              <p>2018年8月31日，中华人民共和国主席习近平签署中华人民共和国主席令（第七号），《中华人民共和国电子商务法》已由中华人民共和国第十三届全国人民代表大会常务委员会第五次会议于2018年8月31日通过。</p>
              <h3>内容解读</h3>
              <p>北京大学法学院教授薛军称，电子商务法草案由全国人大财经委主持，立法效力层次非常高，也是想为我国电子商务的发展奠定一个基本的法律框架，所以立法涉及的面很广，涉及电子商务经营主体、经营行为、合同、快递物流、电子支付等，以及电子商务发展中比较典型的问题，都做了比较明确具体的规定，想为电子商务健康发展奠定法律框架，因为不能依赖一个部委，视角上就要求更加协调。</p>
              <h3>保护权益</h3>
              <h5>搭售须有显著提示</h5>
              <p>针对这样的恼人搭售，电商法草案三审稿增加规定：电子商务经营者搭售商品或服务，应当以显著方式提请消费者注意，不得将搭售商品或者服务作为默认同意的选项。</p>
              <h5>保证押金顺利退还</h5>
              <p>针对押金退还难的问题，草案三审稿增加了如下规定：电子商务经营者按照约定向消费者收取押金的，应当明示押金退还的方式、程序，不得对押金退还设置不合理条件。消费者申请退还押金，符合押金退还条件的，电子商务经营者应当及时退还。</p>
              <h5>向“大数据杀熟”说不</h5>
              <p>草案三审稿明确规定：电子商务经营者根据消费者的兴趣爱好、消费习惯等特征向其推销商品或者服务，应当同时向该消费者提供不针对其个人特征的选项，尊重和平等保护消费者合法权益。</p>
              <h5>个人信息保护有待加强</h5>
              <p>草案指出，电子商务经营者收集、使用其用户的个人信息，应当遵守有关法律、行政法规规定的个人信息保护规则。对此，在分组审议中，不少委员建议应进一步完善对个人信息保护的相关规定。</p>
              <h3>法律全文</h3>
              <h5>中华人民共和国电子商务法</h5>
              <p>（2018年8月31日第十三届全国人民代表大会常务委员会第五次会议通过）</p>
              <h4>第一章　总则</h4>
              <p>第一条　为了保障电子商务各方主体的合法权益，规范电子商务行为，维护市场秩序，促进电子商务持续健康发展，制定本法。</p>
              <p>第二条　中华人民共和国境内的电子商务活动，适用本法。</p>
              <p>本法所称电子商务，是指通过互联网等信息网络销售商品或者提供服务的经营活动。</p>
              <p>法律、行政法规对销售商品或者提供服务有规定的，适用其规定。金融类产品和服务，利用信息网络提供新闻信息、音视频节目、出版以及文化产品等内容方面的服务，不适用本法。</p>
              <p>第三条　国家鼓励发展电子商务新业态，创新商业模式，促进电子商务技术研发和推广应用，推进电子商务诚信体系建设，营造有利于电子商务创新发展的市场环境，充分发挥电子商务在推动高质量发展、满足人民日益增长的美好生活需要、构建开放型经济方面的重要作用。</p>
              <p>第四条　国家平等对待线上线下商务活动，促进线上线下融合发展，各级人民政府和有关部门不得采取歧视性的政策措施，不得滥用行政权力排除、限制市场竞争。</p>
              <p>第五条　电子商务经营者从事经营活动，应当遵循自愿、平等、公平、诚信的原则，遵守法律和商业道德，公平参与市场竞争，履行消费者权益保护、环境保护、知识产权保护、网络安全与个人信息保护等方面的义务，承担产品和服务质量责任，接受政府和社会的监督。</p>
              <p>第六条　国务院有关部门按照职责分工负责电子商务发展促进、监督管理等工作。县级以上地方各级人民政府可以根据本行政区域的实际情况，确定本行政区域内电子商务的部门职责划分。</p>
              <p>第七条　国家建立符合电子商务特点的协同管理体系，推动形成有关部门、电子商务行业组织、电子商务经营者、消费者等共同参与的电子商务市场治理体系。</p>
              <p>第八条　电子商务行业组织按照本组织章程开展行业自律，建立健全行业规范，推动行业诚信建设，监督、引导本行业经营者公平参与市场竞争。</p>
              <h4>第二章　电子商务经营者</h4>
              <p>第一节　一般规定</p>
              <p>第九条　本法所称电子商务经营者，是指通过互联网等信息网络从事销售商品或者提供服务的经营活动的自然人、法人和非法人组织，包括电子商务平台经营者、平台内经营者以及通过自建网站、其他网络服务销售商品或者提供服务的电子商务经营者。</p>
              <p>本法所称电子商务平台经营者，是指在电子商务中为交易双方或者多方提供网络经营场所、交易撮合、信息发布等服务，供交易双方或者多方独立开展交易活动的法人或者非法人组织。</p>
              <p>本法所称平台内经营者，是指通过电子商务平台销售商品或者提供服务的电子商务经营者。</p>
              <p>第十条　电子商务经营者应当依法办理市场主体登记。但是，个人销售自产农副产品、家庭手工业产品，个人利用自己的技能从事依法无须取得许可的便民劳务活动和零星小额交易活动，以及依照法律、行政法规不需要进行登记的除外。</p>
              <p>第十一条　电子商务经营者应当依法履行纳税义务，并依法享受税收优惠。</p>
              <p>依照前条规定不需要办理市场主体登记的电子商务经营者在首次纳税义务发生后，应当依照税收征收管理法律、行政法规的规定申请办理税务登记，并如实申报纳税。</p>
              <p>第十二条　电子商务经营者从事经营活动，依法需要取得相关行政许可的，应当依法取得行政许可。</p>
              <p>第十三条　电子商务经营者销售的商品或者提供的服务应当符合保障人身、财产安全的要求和环境保护要求，不得销售或者提供法律、行政法规禁止交易的商品或者服务。</p>
              <p>第十四条　电子商务经营者销售商品或者提供服务应当依法出具纸质发票或者电子发票等购货凭证或者服务单据。电子发票与纸质发票具有同等法律效力。</p>
              <p>第十五条　电子商务经营者应当在其首页显著位置，持续公示营业执照信息、与其经营业务有关的行政许可信息、属于依照本法第十条规定的不需要办理市场主体登记情形等信息，或者上述信息的链接标识。</p>
              <p>前款规定的信息发生变更的，电子商务经营者应当及时更新公示信息。</p>
              <p>第十六条　电子商务经营者自行终止从事电子商务的，应当提前三十日在首页显著位置持续公示有关信息。</p>
              <p>第十七条　电子商务经营者应当全面、真实、准确、及时地披露商品或者服务信息，保障消费者的知情权和选择权。电子商务经营者不得以虚构交易、编造用户评价等方式进行虚假或者引人误解的商业宣传，欺骗、误导消费者。</p>
              <p>第十八条　电子商务经营者根据消费者的兴趣爱好、消费习惯等特征向其提供商品或者服务的搜索结果的，应当同时向该消费者提供不针对其个人特征的选项，尊重和平等保护消费者合法权益。</p>
              <p>电子商务经营者向消费者发送广告的，应当遵守《中华人民共和国广告法》的有关规定。</p>
              <p>第十九条　电子商务经营者搭售商品或者服务，应当以显著方式提请消费者注意，不得将搭售商品或者服务作为默认同意的选项。</p>
              <p>第二十条　电子商务经营者应当按照承诺或者与消费者约定的方式、时限向消费者交付商品或者服务，并承担商品运输中的风险和责任。但是，消费者另行选择快递物流服务提供者的除外。</p>
              <p>第二十一条　电子商务经营者按照约定向消费者收取押金的，应当明示押金退还的方式、程序，不得对押金退还设置不合理条件。消费者申请退还押金，符合押金退还条件的，电子商务经营者应当及时退还。</p>
              <p>第二十二条　电子商务经营者因其技术优势、用户数量、对相关行业的控制能力以及其他经营者对该电子商务经营者在交易上的依赖程度等因素而具有市场支配地位的，不得滥用市场支配地位，排除、限制竞争。</p>
              <p>第二十三条　电子商务经营者收集、使用其用户的个人信息，应当遵守法律、行政法规有关个人信息保护的规定。</p>
              <p>第二十四条　电子商务经营者应当明示用户信息查询、更正、删除以及用户注销的方式、程序，不得对用户信息查询、更正、删除以及用户注销设置不合理条件。</p>
              <p>电子商务经营者收到用户信息查询或者更正、删除的申请的，应当在核实身份后及时提供查询或者更正、删除用户信息。用户注销的，电子商务经营者应当立即删除该用户的信息；依照法律、行政法规的规定或者双方约定保存的，依照其规定。</p>
              <p>第二十五条　有关主管部门依照法律、行政法规的规定要求电子商务经营者提供有关电子商务数据信息的，电子商务经营者应当提供。有关主管部门应当采取必要措施保护电子商务经营者提供的数据信息的安全，并对其中的个人信息、隐私和商业秘密严格保密，不得泄露、出售或者非法向他人提供。</p>
              <p>第二十六条　电子商务经营者从事跨境电子商务，应当遵守进出口监督管理的法律、行政法规和国家有关规定。</p>
              <p>第二节　电子商务平台经营者</p>
              <p>第二十七条　电子商务平台经营者应当要求申请进入平台销售商品或者提供服务的经营者提交其身份、地址、联系方式、行政许可等真实信息，进行核验、登记，建立登记档案，并定期核验更新。</p>
              <p>电子商务平台经营者为进入平台销售商品或者提供服务的非经营用户提供服务，应当遵守本节有关规定。</p>
              <p>第二十八条　电子商务平台经营者应当按照规定向市场监督管理部门报送平台内经营者的身份信息，提示未办理市场主体登记的经营者依法办理登记，并配合市场监督管理部门，针对电子商务的特点，为应当办理市场主体登记的经营者办理登记提供便利。</p>
              <p>电子商务平台经营者应当依照税收征收管理法律、行政法规的规定，向税务部门报送平台内经营者的身份信息和与纳税有关的信息，并应当提示依照本法第十条规定不需要办理市场主体登记的电子商务经营者依照本法第十一条第二款的规定办理税务登记。</p>
              <p>第二十九条　电子商务平台经营者发现平台内的商品或者服务信息存在违反本法第十二条、第十三条规定情形的，应当依法采取必要的处置措施，并向有关主管部门报告。</p>
              <p>第三十条　电子商务平台经营者应当采取技术措施和其他必要措施保证其网络安全、稳定运行，防范网络违法犯罪活动，有效应对网络安全事件，保障电子商务交易安全。</p>
              <p>电子商务平台经营者应当制定网络安全事件应急预案，发生网络安全事件时，应当立即启动应急预案，采取相应的补救措施，并向有关主管部门报告。</p>
              <p>第三十一条　电子商务平台经营者应当记录、保存平台上发布的商品和服务信息、交易信息，并确保信息的完整性、保密性、可用性。商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。</p>
              <p>第三十二条　电子商务平台经营者应当遵循公开、公平、公正的原则，制定平台服务协议和交易规则，明确进入和退出平台、商品和服务质量保障、消费者权益保护、个人信息保护等方面的权利和义务。</p>
              <p>第三十三条　电子商务平台经营者应当在其首页显著位置持续公示平台服务协议和交易规则信息或者上述信息的链接标识，并保证经营者和消费者能够便利、完整地阅览和下载。</p>
              <p>第三十四条　电子商务平台经营者修改平台服务协议和交易规则，应当在其首页显著位置公开征求意见，采取合理措施确保有关各方能够及时充分表达意见。修改内容应当至少在实施前七日予以公示。</p>
              <p>平台内经营者不接受修改内容，要求退出平台的，电子商务平台经营者不得阻止，并按照修改前的服务协议和交易规则承担相关责任。</p>
              <p>第三十五条　电子商务平台经营者不得利用服务协议、交易规则以及技术等手段，对平台内经营者在平台内的交易、交易价格以及与其他经营者的交易等进行不合理限制或者附加不合理条件，或者向平台内经营者收取不合理费用。</p>
              <p>第三十六条　电子商务平台经营者依据平台服务协议和交易规则对平台内经营者违反法律、法规的行为实施警示、暂停或者终止服务等措施的，应当及时公示。</p>
              <p>第三十七条　电子商务平台经营者在其平台上开展自营业务的，应当以显著方式区分标记自营业务和平台内经营者开展的业务，不得误导消费者。</p>
              <p>电子商务平台经营者对其标记为自营的业务依法承担商品销售者或者服务提供者的民事责任。</p>
              <p>第三十八条　电子商务平台经营者知道或者应当知道平台内经营者销售的商品或者提供的服务不符合保障人身、财产安全的要求，或者有其他侵害消费者合法权益行为，未采取必要措施的，依法与该平台内经营者承担连带责任。</p>
              <p>对关系消费者生命健康的商品或者服务，电子商务平台经营者对平台内经营者的资质资格未尽到审核义务，或者对消费者未尽到安全保障义务，造成消费者损害的，依法承担相应的责任。</p>
              <p>第三十九条　电子商务平台经营者应当建立健全信用评价制度，公示信用评价规则，为消费者提供对平台内销售的商品或者提供的服务进行评价的途径。</p>
              <p>电子商务平台经营者不得删除消费者对其平台内销售的商品或者提供的服务的评价。</p>
              <p>第四十条　电子商务平台经营者应当根据商品或者服务的价格、销量、信用等以多种方式向消费者显示商品或者服务的搜索结果；对于竞价排名的商品或者服务，应当显著标明“广告”。</p>
              <p>第四十一条　电子商务平台经营者应当建立知识产权保护规则，与知识产权权利人加强合作，依法保护知识产权。</p>
              <p>第四十二条　知识产权权利人认为其知识产权受到侵害的，有权通知电子商务平台经营者采取删除、屏蔽、断开链接、终止交易和服务等必要措施。通知应当包括构成侵权的初步证据。</p>
              <p>电子商务平台经营者接到通知后，应当及时采取必要措施，并将该通知转送平台内经营者；未及时采取必要措施的，对损害的扩大部分与平台内经营者承担连带责任。</p>
              <p>因通知错误造成平台内经营者损害的，依法承担民事责任。恶意发出错误通知，造成平台内经营者损失的，加倍承担赔偿责任。</p>
              <p>第四十三条　平台内经营者接到转送的通知后，可以向电子商务平台经营者提交不存在侵权行为的声明。声明应当包括不存在侵权行为的初步证据。</p>
              <p>电子商务平台经营者接到声明后，应当将该声明转送发出通知的知识产权权利人，并告知其可以向有关主管部门投诉或者向人民法院起诉。电子商务平台经营者在转送声明到达知识产权权利人后十五日内，未收到权利人已经投诉或者起诉通知的，应当及时终止所采取的措施。</p>
              <p>第四十四条　电子商务平台经营者应当及时公示收到的本法第四十二条、第四十三条规定的通知、声明及处理结果。</p>
              <p>第四十五条　电子商务平台经营者知道或者应当知道平台内经营者侵犯知识产权的，应当采取删除、屏蔽、断开链接、终止交易和服务等必要措施；未采取必要措施的，与侵权人承担连带责任。</p>
              <p>第四十六条　除本法第九条第二款规定的服务外，电子商务平台经营者可以按照平台服务协议和交易规则，为经营者之间的电子商务提供仓储、物流、支付结算、交收等服务。电子商务平台经营者为经营者之间的电子商务提供服务，应当遵守法律、行政法规和国家有关规定，不得采取集中竞价、做市商等集中交易方式进行交易，不得进行标准化合约交易。</p>
              <h4>第三章　电子商务合同的订立与履行</h4>
              <p>第四十七条　电子商务当事人订立和履行合同，适用本章和《中华人民共和国民法总则》《中华人民共和国合同法》《中华人民共和国电子签名法》等法律的规定。</p>
              <p>第四十八条　电子商务当事人使用自动信息系统订立或者履行合同的行为对使用该系统的当事人具有法律效力。</p>
              <p>在电子商务中推定当事人具有相应的民事行为能力。但是，有相反证据足以推翻的除外。</p>
              <p>第四十九条　电子商务经营者发布的商品或者服务信息符合要约条件的，用户选择该商品或者服务并提交订单成功，合同成立。当事人另有约定的，从其约定。</p>
              <p>电子商务经营者不得以格式条款等方式约定消费者支付价款后合同不成立；格式条款等含有该内容的，其内容无效。</p>
              <p>第五十条　电子商务经营者应当清晰、全面、明确地告知用户订立合同的步骤、注意事项、下载方法等事项，并保证用户能够便利、完整地阅览和下载。</p>
              <p>电子商务经营者应当保证用户在提交订单前可以更正输入错误。</p>
              <p>第五十一条　合同标的为交付商品并采用快递物流方式交付的，收货人签收时间为交付时间。合同标的为提供服务的，生成的电子凭证或者实物凭证中载明的时间为交付时间；前述凭证没有载明时间或者载明时间与实际提供服务时间不一致的，实际提供服务的时间为交付时间。</p>
              <p>合同标的为采用在线传输方式交付的，合同标的进入对方当事人指定的特定系统并且能够检索识别的时间为交付时间。</p>
              <p>合同当事人对交付方式、交付时间另有约定的，从其约定。</p>
              <p>第五十二条　电子商务当事人可以约定采用快递物流方式交付商品。</p>
              <p>快递物流服务提供者为电子商务提供快递物流服务，应当遵守法律、行政法规，并应当符合承诺的服务规范和时限。快递物流服务提供者在交付商品时，应当提示收货人当面查验；交由他人代收的，应当经收货人同意。</p>
              <p>快递物流服务提供者应当按照规定使用环保包装材料，实现包装材料的减量化和再利用。</p>
              <p>快递物流服务提供者在提供快递物流服务的同时，可以接受电子商务经营者的委托提供代收货款服务。</p>
              <p>第五十三条　电子商务当事人可以约定采用电子支付方式支付价款。</p>
              <p>电子支付服务提供者为电子商务提供电子支付服务，应当遵守国家规定，告知用户电子支付服务的功能、使用方法、注意事项、相关风险和收费标准等事项，不得附加不合理交易条件。电子支付服务提供者应当确保电子支付指令的完整性、一致性、可跟踪稽核和不可篡改。</p>
              <p>电子支付服务提供者应当向用户免费提供对账服务以及最近三年的交易记录。</p>
              <p>第五十四条　电子支付服务提供者提供电子支付服务不符合国家有关支付安全管理要求，造成用户损失的，应当承担赔偿责任。</p>
              <p>第五十五条　用户在发出支付指令前，应当核对支付指令所包含的金额、收款人等完整信息。</p>
              <p>支付指令发生错误的，电子支付服务提供者应当及时查找原因，并采取相关措施予以纠正。造成用户损失的，电子支付服务提供者应当承担赔偿责任，但能够证明支付错误非自身原因造成的除外。</p>
              <p>第五十六条　电子支付服务提供者完成电子支付后，应当及时准确地向用户提供符合约定方式的确认支付的信息。</p>
              <p>第五十七条　用户应当妥善保管交易密码、电子签名数据等安全工具。用户发现安全工具遗失、被盗用或者未经授权的支付的，应当及时通知电子支付服务提供者。</p>
              <p>未经授权的支付造成的损失，由电子支付服务提供者承担；电子支付服务提供者能够证明未经授权的支付是因用户的过错造成的，不承担责任。</p>
              <p>电子支付服务提供者发现支付指令未经授权，或者收到用户支付指令未经授权的通知时，应当立即采取措施防止损失扩大。电子支付服务提供者未及时采取措施导致损失扩大的，对损失扩大部分承担责任。</p>
              <h4>第四章　电子商务争议解决</h4>
              <p>第五十八条　国家鼓励电子商务平台经营者建立有利于电子商务发展和消费者权益保护的商品、服务质量担保机制。</p>
              <p>电子商务平台经营者与平台内经营者协议设立消费者权益保证金的，双方应当就消费者权益保证金的提取数额、管理、使用和退还办法等作出明确约定。</p>
              <p>消费者要求电子商务平台经营者承担先行赔偿责任以及电子商务平台经营者赔偿后向平台内经营者的追偿，适用《中华人民共和国消费者权益保护法》的有关规定。</p>
              <p>第五十九条　电子商务经营者应当建立便捷、有效的投诉、举报机制，公开投诉、举报方式等信息，及时受理并处理投诉、举报。</p>
              <p>第六十条　电子商务争议可以通过协商和解，请求消费者组织、行业协会或者其他依法成立的调解组织调解，向有关部门投诉，提请仲裁，或者提起诉讼等方式解决。</p>
              <p>第六十一条　消费者在电子商务平台购买商品或者接受服务，与平台内经营者发生争议时，电子商务平台经营者应当积极协助消费者维护合法权益。</p>
              <p>第六十二条　在电子商务争议处理中，电子商务经营者应当提供原始合同和交易记录。因电子商务经营者丢失、伪造、篡改、销毁、隐匿或者拒绝提供前述资料，致使人民法院、仲裁机构或者有关机关无法查明事实的，电子商务经营者应当承担相应的法律责任。</p>
              <p>第六十三条　电子商务平台经营者可以建立争议在线解决机制，制定并公示争议解决规则，根据自愿原则，公平、公正地解决当事人的争议。</p>
              <h4>第五章　电子商务促进</h4>
              <p>第六十四条　国务院和省、自治区、直辖市人民政府应当将电子商务发展纳入国民经济和社会发展规划，制定科学合理的产业政策，促进电子商务创新发展。</p>
              <p>第六十五条　国务院和县级以上地方人民政府及其有关部门应当采取措施，支持、推动绿色包装、仓储、运输，促进电子商务绿色发展。</p>
              <p>第六十六条　国家推动电子商务基础设施和物流网络建设，完善电子商务统计制度，加强电子商务标准体系建设。</p>
              <p>第六十七条　国家推动电子商务在国民经济各个领域的应用，支持电子商务与各产业融合发展。</p>
              <p>第六十八条　国家促进农业生产、加工、流通等环节的互联网技术应用，鼓励各类社会资源加强合作，促进农村电子商务发展，发挥电子商务在精准扶贫中的作用。</p>
              <p>第六十九条　国家维护电子商务交易安全，保护电子商务用户信息，鼓励电子商务数据开发应用，保障电子商务数据依法有序自由流动。</p>
              <p>国家采取措施推动建立公共数据共享机制，促进电子商务经营者依法利用公共数据。</p>
              <p>第七十条　国家支持依法设立的信用评价机构开展电子商务信用评价，向社会提供电子商务信用评价服务。</p>
              <p>第七十一条　国家促进跨境电子商务发展，建立健全适应跨境电子商务特点的海关、税收、进出境检验检疫、支付结算等管理制度，提高跨境电子商务各环节便利化水平，支持跨境电子商务平台经营者等为跨境电子商务提供仓储物流、报关、报检等服务。</p>
              <p>国家支持小型微型企业从事跨境电子商务。</p>
              <p>第七十二条　国家进出口管理部门应当推进跨境电子商务海关申报、纳税、检验检疫等环节的综合服务和监管体系建设，优化监管流程，推动实现信息共享、监管互认、执法互助，提高跨境电子商务服务和监管效率。跨境电子商务经营者可以凭电子单证向国家进出口管理部门办理有关手续。</p>
              <p>第七十三条　国家推动建立与不同国家、地区之间跨境电子商务的交流合作，参与电子商务国际规则的制定，促进电子签名、电子身份等国际互认。</p>
              <p>国家推动建立与不同国家、地区之间的跨境电子商务争议解决机制。</p>
              <h4>第六章　法律责任</h4>
              <p>第七十四条　电子商务经营者销售商品或者提供服务，不履行合同义务或者履行合同义务不符合约定，或者造成他人损害的，依法承担民事责任。</p>
              <p>第七十五条　电子商务经营者违反本法第十二条、第十三条规定，未取得相关行政许可从事经营活动，或者销售、提供法律、行政法规禁止交易的商品、服务，或者不履行本法第二十五条规定的信息提供义务，电子商务平台经营者违反本法第四十六条规定，采取集中交易方式进行交易，或者进行标准化合约交易的，依照有关法律、行政法规的规定处罚。</p>
              <p>第七十六条　电子商务经营者违反本法规定，有下列行为之一的，由市场监督管理部门责令限期改正，可以处一万元以下的罚款，对其中的电子商务平台经营者，依照本法第八十一条第一款的规定处罚：</p>
              <p>（一）未在首页显著位置公示营业执照信息、行政许可信息、属于不需要办理市场主体登记情形等信息，或者上述信息的链接标识的；</p>
              <p>（二）未在首页显著位置持续公示终止电子商务的有关信息的；</p>
              <p>（三）未明示用户信息查询、更正、删除以及用户注销的方式、程序，或者对用户信息查询、更正、删除以及用户注销设置不合理条件的。</p>
              <p>电子商务平台经营者对违反前款规定的平台内经营者未采取必要措施的，由市场监督管理部门责令限期改正，可以处二万元以上十万元以下的罚款。</p>
              <p>第七十七条　电子商务经营者违反本法第十八条第一款规定提供搜索结果，或者违反本法第十九条规定搭售商品、服务的，由市场监督管理部门责令限期改正，没收违法所得，可以并处五万元以上二十万元以下的罚款；情节严重的，并处二十万元以上五十万元以下的罚款。</p>
              <p>第七十八条　电子商务经营者违反本法第二十一条规定，未向消费者明示押金退还的方式、程序，对押金退还设置不合理条件，或者不及时退还押金的，由有关主管部门责令限期改正，可以处五万元以上二十万元以下的罚款；情节严重的，处二十万元以上五十万元以下的罚款。</p>
              <p>第八十条　电子商务平台经营者有下列行为之一的，由有关主管部门责令限期改正；逾期不改正的，处二万元以上十万元以下的罚款；情节严重的，责令停业整顿，并处十万元以上五十万元以下的罚款：</p>
              <p>（一）不履行本法第二十七条规定的核验、登记义务的；</p>
              <p>（二）不按照本法第二十八条规定向市场监督管理部门、税务部门报送有关信息的；</p>
              <p>（三）不按照本法第二十九条规定对违法情形采取必要的处置措施，或者未向有关主管部门报告的；</p>
              <p>（四）不履行本法第三十一条规定的商品和服务信息、交易信息保存义务的。</p>
              <p>法律、行政法规对前款规定的违法行为的处罚另有规定的，依照其规定。</p>
              <p>第八十一条　电子商务平台经营者违反本法规定，有下列行为之一的，由市场监督管理部门责令限期改正，可以处二万元以上十万元以下的罚款；情节严重的，处十万元以上五十万元以下的罚款：</p>
              <p>（一）未在首页显著位置持续公示平台服务协议、交易规则信息或者上述信息的链接标识的；</p>
              <p>（二）修改交易规则未在首页显著位置公开征求意见，未按照规定的时间提前公示修改内容，或者阻止平台内经营者退出的；</p>
              <p>（三）未以显著方式区分标记自营业务和平台内经营者开展的业务的；</p>
              <p>（四）未为消费者提供对平台内销售的商品或者提供的服务进行评价的途径，或者擅自删除消费者的评价的。</p>
              <p>电子商务平台经营者违反本法第四十条规定，对竞价排名的商品或者服务未显著标明“广告”的，依照《中华人民共和国广告法》的规定处罚。</p>
              <p>第八十二条　电子商务平台经营者违反本法第三十五条规定，对平台内经营者在平台内的交易、交易价格或者与其他经营者的交易等进行不合理限制或者附加不合理条件，或者向平台内经营者收取不合理费用的，由市场监督管理部门责令限期改正，可以处五万元以上五十万元以下的罚款；情节严重的，处五十万元以上二百万元以下的罚款。</p>
              <p>第八十三条　电子商务平台经营者违反本法第三十八条规定，对平台内经营者侵害消费者合法权益行为未采取必要措施，或者对平台内经营者未尽到资质资格审核义务，或者对消费者未尽到安全保障义务的，由市场监督管理部门责令限期改正，可以处五万元以上五十万元以下的罚款；情节严重的，责令停业整顿，并处五十万元以上二百万元以下的罚款。</p>
              <p>第八十四条　电子商务平台经营者违反本法第四十二条、第四十五条规定，对平台内经营者实施侵犯知识产权行为未依法采取必要措施的，由有关知识产权行政部门责令限期改正；逾期不改正的，处五万元以上五十万元以下的罚款；情节严重的，处五十万元以上二百万元以下的罚款。</p>
              <p>第八十五条　电子商务经营者违反本法规定，销售的商品或者提供的服务不符合保障人身、财产安全的要求，实施虚假或者引人误解的商业宣传等不正当竞争行为，滥用市场支配地位，或者实施侵犯知识产权、侵害消费者权益等行为的，依照有关法律的规定处罚。</p>
              <p>第八十六条　电子商务经营者有本法规定的违法行为的，依照有关法律、行政法规的规定记入信用档案，并予以公示。</p>
              <p>第八十七条　依法负有电子商务监督管理职责的部门的工作人员，玩忽职守、滥用职权、徇私舞弊，或者泄露、出售或者非法向他人提供在履行职责中所知悉的个人信息、隐私和商业秘密的，依法追究法律责任。</p>
              <p>第八十八条　违反本法规定，构成违反治安管理行为的，依法给予治安管理处罚；构成犯罪的，依法追究刑事责任。</p>
              <h4>第七章　附则</h4>
              <p>第八十九条　本法自2019年1月1日起施行。</p>
            </div>
          </el-dialog>
            <el-dialog
                  title="2020年授权直营零售商管理条例"
                  :visible.sync="presaleVisible"
                  width="7rem"
                  center>
            <div style="width: 100%">
              <img style="width: 100%" src="../assets/yd.jpg" alt="">
            </div>
          </el-dialog>
  </div>
</template>

<script>
import {Authorization_api} from '../request/api'
export default {
  name: "NewLiuyanShopWebAuthorization",
  components: {},
  directives: {},
  data() {
    return {
        wechat: '',
        oldwechat:'',
        centerDialogVisible: false,
        presaleVisible: false,
        hidden: false,
        tps: false,
        imgs: false,
        text: '',
        imgUrl: '',
        // imagesurl:'http://www.sitemerge.com/'
        imagesurl:'https://cdnunified.liuyanniangzhi.com/'
    };
  },
  mounted() {},
  methods: {
      onSubmit(){
        if (this.wechat == "") {
          this.tps = true
          this.hidden = false
          this.imgs = false
          return true
        } else {
          var regex_wx = /^[a-zA-Z_][a-zA-Z0-9_-]*$/;
          var regex_gs = /^[\u4E00-\u9FFF]+$/;
          var type=0;
          if(regex_wx.test(this.wechat)){
            type=0
          }else if(regex_gs.test(this.wechat)){
            type=1
          }
          if(this.wechat!=this.oldwechat){
            Authorization_api({weixin: this.wechat,sign:"liuyan",type:type}).then((res)=>{
               if(res.data.code === 200){
                    this.imgs = true
                    this.hidden = false
                    this.tps = false
                    this.imgUrl = res.data.data.path
                    this.$refs.formbox.style = 'background: url(../../static/sq3.png) no-repeat center center/100% 100%;border-image:url(../../static/sq2.png) 63 57 62 58 round;'
                    // this.$refs.jumbotron_title.style.width = '80%'
                    this.$refs.jumbotron_title.style.padding = '0 4%'
               }else if(res.data.code === 203){
                    this.tps = false
                    this.text = res.data.message
                    this.hidden = true
                    this.imgs = false
                    this.$refs.formbox.style = 'background: url(../../static/sq1.png) no-repeat center center/100% 100%;border-image:url(../../static/sq.png) 65 60 65 60 round;'
                    // this.$refs.jumbotron_title.style.width = '40%'
                    this.$refs.jumbotron_title.style.padding = '0 30%'
               }
               this.oldwechat=this.wechat
            })            
          }else{
            console.log('已查询出结果')
          }
        }
      },
  },
};
</script>

<style lang="less" scoped>
.Authcontainer {
  // min-height: calc(100vh - 300px);
  width: 100%;
  color: #00383f;
  overflow: hidden;
  text-align: center;
   font-family: 'SimSun';
  .way{
      color: #00383f;
  }
  .formbox {
    max-width: 961px;
    width: 100%;
    padding-bottom: 2%;
    margin: 10% auto;
    // background: url(../../static/sq.png) no-repeat center center/100% 100%;
    background: url(../../static/sq1.png) center center / 100% 100% no-repeat;
    border-color: transparent;
    border-style: solid;
    border-width: 65px 60px 65px 60px;
    border-image: url(../../static/sq.png) 65 60 65 60 round;
    box-sizing: border-box;
    h3 {
        padding-top: 5%;
        padding-bottom: 5%;
        font-size: 36px;
        font-family: 'SimSun';
        font-weight: bold;
        color: #00383f;
        line-height: 32px;
      }
    .jumbotron_title {
      padding: 0 30%;
      .button {
        width: 100%;
        background: #00383f;
        padding: 2% 0;
        margin-top: 30px;
        border-radius: 5px;
        color: #fff;
        font-size: 26px;
        border: unset;
         font-family: 'SimSun';
      }
      .Pcursor{
            font-size: 16px;
            font-family: Source Han Serif CN;
            font-weight: 500;
            color: red;
            margin-top: 3%;
            font-weight: 500;
      }
      .nrts{
          padding-top: 7%;
          color: #00383f;
          font-size: 18px;
      }
    }
  }
}
/deep/input.el-input__inner {
    text-align: center!important;
    min-height: 51.69px;
        border: 1px solid #00383F;
        font-size: 18px;
}
/deep/.nput__inner:focus {
    border-color: #00383f;
    outline: 0;
}
@media (max-width: 991px) {
 .mobAuthcontainer{
    margin: 0 0.8rem;
    min-height: 100vh;
 .jumbotron_title{
   h3{
     font-size: 0.48rem;
     padding-top: 1.5rem;
     padding-bottom: 0.91rem;
    font-weight: 900;
   }
   .button {
     width:100%;
      height: 0.9rem;
      background: #00383F;
      border: 1px solid #00383F;
      margin-top: 0.59rem;
      font-weight: 900;
      color: #F8FFFF;     
      font-size: 0.33rem;
      letter-spacing: 0.02rem;
   }
   .Pcursor{
      font-size: 0.29rem;
      color: red;
      font-weight: 900;
      margin-top: 0.58rem;
   }
    a{
      display: block;
      font-size: 0.3rem;
      font-weight: 900;
      margin-top: 0.1rem;
     }
     .nrts{
       margin-top: 0.59rem;
       color: #00383F;
       line-height: 0.5rem;
       font-weight: bold;
     }
 }
 /deep/.el-input__inner{
   font-size: 0.3rem;
   height: 0.91rem;
 }
 ::-webkit-input-placeholder{
   font-size: 0.3rem;
 }
 /deep/.el-dialog--center{
   width: 6rem!important;
 }
 }
}
</style>


// WEBPACK FOOTER //
// src/view/Authorization.vue